<button class="icon" *ngIf="type === 'facebook'" (click)="share()"><img src="../../../../../assets/images/facebook.png"></button>

<button class="icon" *ngIf="type === 'linkedin'" (click)="share()"><img src="../../../../../assets/images/linkedin.png"></button>
